import React, { useEffect, useState } from 'react';
import { FileTextIcon, LandmarkIcon, ListIcon, ReceiptTextIcon } from 'lucide-react';
import { sourceDocuments } from '../../data/documents';
import { useAssessment } from '../../contexts/AssessmentContext';
import { DocumentKind } from '../../types/assessment';
const icons: Record<DocumentKind, typeof FileTextIcon> = {
  'Bank Statement': LandmarkIcon,
  Invoice: ReceiptTextIcon,
  Schedule: ListIcon,
  Memo: FileTextIcon
};
export function DocumentViewer() {
  const {
    openDocument
  } = useAssessment();
  const [activeId, setActiveId] = useState(sourceDocuments[0].id);
  const active = sourceDocuments.find(d => d.id === activeId) || sourceDocuments[0];
  useEffect(() => {
    openDocument(active.id, active.title);
  }, [active.id, active.title, openDocument]);
  return <div className="flex h-full min-h-0" data-id="element-190" data-mp="2eqmv997oknl7">
      <aside className="w-64 shrink-0 overflow-y-auto border-r border-slate-200 bg-slate-50" data-id="element-191" data-mp="2eplbmgclmsrv">
        <p className="px-4 pb-2 pt-4 text-[11px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-192" data-mp="2jn3lqa2cre1g">
          Source documents
        </p>
        <ul className="pb-4" data-id="element-193" data-mp="3nll6tgr3xyhc">
          {sourceDocuments.map(doc => {
          const Icon = icons[doc.kind];
          const selected = doc.id === activeId;
          return <li key={doc.id} data-id="element-194" data-mp="3dviap7oow4es">
                <button type="button" onClick={() => setActiveId(doc.id)} className={`flex w-full items-start gap-2.5 border-l-2 px-4 py-2.5 text-left transition-colors ${selected ? 'border-slate-900 bg-white' : 'border-transparent hover:bg-slate-100'}`} data-id="element-195" data-mp="3dugwiucdn1su">
                  <Icon className={`mt-0.5 h-4 w-4 shrink-0 ${selected ? 'text-slate-900' : 'text-slate-400'}`} data-id="element-196" data-mp="2uww5bgm53r52" />
                  <span data-id="element-197" data-mp="y3udrc9oebvz">
                    <span className={`block text-[13px] font-medium leading-snug ${selected ? 'text-slate-900' : 'text-slate-600'}`} data-id="element-198" data-mp="y202kpo7hy53">
                      {doc.title}
                    </span>
                    <span className="font-mono-num text-[11px] text-slate-400" data-id="element-199" data-mp="2sdj3txpgc40u">{doc.id}</span>
                  </span>
                </button>
              </li>;
        })}
        </ul>
      </aside>

      <div className="min-w-0 flex-1 overflow-y-auto bg-slate-200/60 p-6" data-id="element-200" data-mp="2ikbuy2vi65w0">
        <article className="mx-auto max-w-3xl rounded-sm bg-white shadow-lg shadow-slate-400/20 ring-1 ring-slate-300" data-id="element-201" data-mp="36cioku9ufyrq">
          <header className="border-b border-slate-200 px-8 py-6" data-id="element-202" data-mp="3b8zm2f2xnphh">
            <span className="inline-flex items-center rounded-full bg-slate-900 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-white" data-id="element-203" data-mp="2xaj7k1ytwuos">
              {active.kind}
            </span>
            <h3 className="mt-3 text-lg font-semibold text-slate-900" data-id="element-204" data-mp="1lukt1ikvtgg6">{active.title}</h3>
            <p className="mt-1 text-xs text-slate-500" data-id="element-205" data-mp="1pyisxvi16vaa">{active.issuer}</p>
          </header>
          <pre className="whitespace-pre-wrap px-8 py-6 font-mono-num text-[12.5px] leading-relaxed text-slate-800" data-id="element-206" data-mp="1id6vvovuhfjo">
            {active.body.join('\n')}
          </pre>
          <footer className="border-t border-slate-200 px-8 py-3 font-mono-num text-[11px] text-slate-400" data-id="element-207" data-mp="1sc4eycai4gva">
            {active.id} · rendered from source · page 1 of 1
          </footer>
        </article>
      </div>
    </div>;
}